module.exports = __webpack_public_path__ + "img/idx-game-live.4f998a7.webp";